export default {
  getInadimplencia(state) {
    return state.inadimplencia
  }
}
